import { createAction } from '@reduxjs/toolkit';
import {
    typeEncashHistoryFilters,
    typeEncashHistoryItem, typeEncashHistoryState
} from 'model/dashboardEncash/dEncashType';
import { typePagination, typeRequestPagination } from 'model/system/constants';

// ---------------------------------------------------------------------------------------------------------------------

// Action creator of set data
export const dEncashSetDataAC = createAction(
    'D_ENCASH_SET_DATA',
    (dataList: typeEncashHistoryItem[]) => ( { payload: { dataList } } )
)

// Action creator of saga set data
export const dEncashSetDataSagaAC = createAction(
    'D_ENCASH_SET_DATA_SAGA',
    (
        filters: typeEncashHistoryFilters,
        sortDirection: typeEncashHistoryState['sortDirection'],
        paginationRequest: typeRequestPagination
    ) => ( { payload: { filters,sortDirection, paginationRequest } } )
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set item data
export const dEncashSetDetailDataAC = createAction(
    'D_ENCASH_SET_DETAIL_DATA',
    (detailDataId: string) => ( { payload: detailDataId } )
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of clear filtersForm
export const dEncashClearFiltersAC = createAction(
    'D_ENCASH_CLEAR_FILTERS',
)

// Action creator of set filtersForm
export const dEncashSetFiltersAC = createAction(
    'D_ENCASH_SET_FILTERS',
    (filtersObject: typeEncashHistoryFilters) => ( { payload: filtersObject } )
)

// Action creator of set sort direction
export const dEncashSetSortDirectionAC = createAction(
    'D_ENCASH_SET_SORT_DIRECTION',
    (sortDirection: typeEncashHistoryState['sortDirection']) => ( { payload: sortDirection } )
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set pagination
export const dEncashSetPaginationAC = createAction(
    'D_ENCASH_SET_PAGINATION',
    (
        pagination: typePagination,
    ) => ( { payload: { pagination } } )
)

// Action creator of set itemsForPage in pagination
export const dEncashSetItemsForPageAC = createAction(
    'D_ENCASH_SET_ITEMS_FOR_PAGE',
    (
        itemsForPage: number,
    ) => ( { payload: { itemsForPage } } )
)


// Action creator of set pageNumber in pagination
export const dEncashSetPageNumberAC = createAction(
    'D_ENCASH_SET_PAGE_NUMBER',
    (
        pageNumber: number,
    ) => ( { payload: { pageNumber } } )
)

